module.exports = __webpack_public_path__ + "media/wyposazenie/stan-0596201c.png";